import { Field, Form, Formik } from "formik";
import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import * as yup from "yup";
// import { Viewer } from "@react-pdf-viewer/core";
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import img from "../../../Resources/images/japan.jpg";
// import { Worker } from "@react-pdf-viewer/core";
// Import styles
// import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../HOC/CreateAxios/CreateAxios";
import { useNavigate } from "react-router-dom";
// Import the styles
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import axios from "../../UI/CreateAxios/CreateAxios";
function AddBooking() {
  const navigate = useNavigate();
  //   const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [storeImage, setStoreImage] = useState("");
  const [multiSelecting, setMultiSelecting] = useState([]);

  const [Tbody, setTbody] = useState([]);
  const getService = () => {
    axios
      .get("/service")
      .then((res) => {
        console.log(res);
        // setStoreImage("");
        setTbody(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getService();
  }, []);
  let opt = [];
  Tbody.map((val, i) => {
    let datas = { value: val.service_name, id: val.id };
    return opt.push(datas);
  });
  // let opt = [];
  // data.map((val, i) => {
  //   let store = {
  //     id: val.id,
  //     title: val.title,
  //   };
  //   return opt.push(store);
  // });
  const formData = [
    { label: "title", type: "text", placeholder: "title", apikey: "title" },
    { label: "price", type: "number", placeholder: "price", apikey: "price" },
    {
      label: "service",
      type: "select",
      apikey: "service",
      options: [{ id: "0", value: "Select any services" }, ...opt],
    },
    {
      label: "Arriving date",
      type: "date",

      apikey: "date",
    },

    {
      label: "image",
      type: "file",
      accept: "image/*,.jpg,.png,.jpeg,.mov",
      apikey: "image",
    },
  ];
  // const SUPPORTED_FORMATS = [
  //   "image/jpg",
  //   "image/png",
  //   "image/jpeg",
  //   "image/gif",
  // ];
  const Schema = yup.object().shape({
    title: yup.string().required("Title is required"),
    price: yup.string().required("Price is required"),
    // service: yup.string().required("Service is required"),
    date: yup.string().required("Date is required"),
    //   image: yup
    //     .mixed()
    //     .test("required", "You need to provide a file", (value) => {
    //       return value && value.length;
    //     })
    //     .test("fileSize", "The file is too large", (value, context) => {
    //       return value && value[0] && value[0].size <= 10000000;
    //     }),
    //   // .test(
    //   //   "type",
    //   //   "Invalid file extension, use only jpg, jpeg and png file extension",
    //   //   function (value) {
    //   //     return (
    //   //       (value && value[0] && value[0].type === "pdf/jpeg") ||
    //   //       (value && value[0] && value[0].type === "pdf/jpg") ||
    //   //       (value && value[0] && value[0].type === "pdf/png")
    //   //     );
    //   //   }
    //   // ),
  });
  const handleChange = (e) => {
    // alert("working");
    if (e.target.files.length !== 0) {
      // setStoreImage([...storeImage, e.target.files[0]]);
      setStoreImage(e.target.files[0]);
    }
  };
  // const RemoveImage = (i) => {
  //   let data = [...storeImage];
  //   data.splice(i, 1);
  //   setStoreImage(data);
  // };
  const [showData] = useState("");
  const Submit = (value) => {
    value.image = storeImage;

    console.log(multiSelecting);
    let formData = new FormData();
    formData.append("image", storeImage);
    formData.append("title", value.title);
    formData.append("price", value.price);
    formData.append("date", value.date);
    multiSelecting.map((val, i) => {
      console.log(val);
      return formData.append(
        "service[]",
        JSON.stringify({ service_id: val.id, name: val.value })
      );
    });

    axios
      .post(`/booking`, formData)
      .then((res) => {
        // alert("working1");
        setStoreImage("");
        toast.success("Event has been booked sucessfully");
        setMultiSelecting([]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const MultiSelect = (e) => {
    let data = e.target.value.split("/");
    setMultiSelecting([...multiSelecting, { id: data[0], value: data[1] }]);
  };
  const RemoveMultiSelecting = (id) => {
    console.log(id);
    let data = [...multiSelecting];
    data.splice(id, 1);
    setMultiSelecting(data);
  };
  return (
    <div>
      <ToastContainer />
      <div className="mx-6">
        <Formik
          initialValues={{
            title: "",
            price: "",
            service: "",
            date: "",
            image: "",
          }}
          validationSchema={Schema}
          onSubmit={(value, { resetForm }) => {
            // console.log(value);
            Submit(value);
            resetForm();
          }}
        >
          {({ errors, touched, handleSubmit }) => {
            return (
              <Form onSubmit={handleSubmit} className="w-8/12">
                {formData.map((val, i) => {
                  if (val.type === "select") {
                    return (
                      <div key={i}>
                        <div className="capitalize  font-medium w-full text-gray-700 my-2">
                          <label
                            htmlFor={val.apikey}
                            className="cursor-pointer"
                          >
                            {val.label}
                          </label>
                        </div>
                        <Field
                          as={val.type}
                          id={val.apikey}
                          name={val.apikey}
                          className={` ${
                            val.apikey ? "focus:border-blue-800" : ""
                          } bg-white    outline-none placeholder:capitalize
                            placeholder:text-sm placeholder:font-light rounded-[4px]
                            w-full  relative z-10  border border-gray-300 px-2 py-2`}
                          key={i}
                          onChange={(e) => MultiSelect(e)}
                        >
                          {val.options
                            ? val.options.length === 0
                              ? null
                              : val?.options?.map((vals, id) => {
                                  return (
                                    <option
                                      key={id}
                                      id={vals.apikey}
                                      name={vals.apikey}
                                      value={vals.id + "/" + vals.value}
                                    >
                                      {vals.value}
                                    </option>
                                  );
                                })
                            : ""}
                        </Field>
                        <div
                          className={`${
                            multiSelecting.length > 0
                              ? "bg-gray-200 w-full p-1 mt-2"
                              : ""
                          }`}
                        >
                          <div className=" w-fit">
                            <div className="flex flex-wrap gap-3 ">
                              {multiSelecting.map((item, i) => {
                                console.log(item);
                                return (
                                  <div
                                    className="
                                w-fit relative   items-center px-2 py-2"
                                  >
                                    <div className="bg-white   px-2 py-2 capitalize rounded-[3px]">
                                      {item.value}
                                      <div
                                        className="bg-red-500 text-white w-fit rounded-full absolute top-0 right-0"
                                        onClick={() => RemoveMultiSelecting(i)}
                                      >
                                        {multiSelecting.length > 0 && (
                                          <MdClose />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                        <div
                          className={`${
                            errors[val.apikey] && touched[val.apikey]
                              ? "text-red-500  my-2 p-0.5 text-sm bg-red-100"
                              : ""
                          } `}
                        >
                          {errors[val.apikey] && touched[val.apikey]
                            ? errors[val.apikey]
                            : ""}
                        </div>
                      </div>
                    );
                  } else if (val.type === "file") {
                    return (
                      <div className="" key={i}>
                        <div className="capitalize font-medium text-gray-700 my-2">
                          <label>{val.label}</label>
                        </div>

                        <div
                          className={`  flex border border-gray-200 rounded-sm space-x-1 gap-3 ${
                            storeImage ? "h-72" : "h-fit"
                          }  `}
                        >
                          <div className="   m-2">
                            <label htmlFor="image">
                              <div className="  capitalize w-24 h-24 cursor-pointer p-1 flex bg-gray-100 items-center justify-center">
                                + add
                              </div>
                            </label>
                          </div>
                          <div
                            className={`w-96   ${
                              storeImage ? "h-60" : "h-fit"
                            } mt-3`}
                          >
                            {storeImage && (
                              <img
                                src={
                                  storeImage.length === "" ||
                                  storeImage.length === 0
                                    ? ""
                                    : URL.createObjectURL(storeImage)
                                }
                                alt="Loading..."
                                className="object-cover w-60  h-60 object-top"
                              />
                            )}
                          </div>
                        </div>

                        <input
                          id="image"
                          type={val.type}
                          accept={val.accept}
                          name={val.apikey}
                          onChange={(e) => handleChange(e)}
                          className="bg-white hidden relative z-50  outline-none rounded-sm
                              border-none px-2 py-1"
                        />
                        <div
                          className={`${
                            errors[val.apikey] && touched[val.apikey]
                              ? "text-red-500  my-2 p-0.5 text-sm bg-red-100"
                              : ""
                          } `}
                        >
                          {errors[val.apikey] && touched[val.apikey]
                            ? errors[val.apikey]
                            : ""}
                        </div>
                      </div>
                    );
                  }
                  // multiple image
                  // if (val.type === "file") {
                  //   return (
                  //     <div className="" key={i}>
                  //       <div className="capitalize font-medium text-gray-700 my-2">
                  //         <label>{val.label}</label>
                  //       </div>

                  //       <div
                  //         className={`grid grid-cols-12  space-x-1 gap-3 border ov p-1 ${
                  //           storeImage.length > 4 ? "h-60" : "h-fit"
                  //         }`}
                  //       >
                  //         <div className="col-span-2  mt-2">
                  //           <label htmlFor="image">
                  //             <div className="  capitalize w-24 h-24 cursor-pointer p-1 flex bg-gray-200 items-center justify-center">
                  //               + add
                  //             </div>
                  //           </label>
                  //         </div>{" "}
                  //         <div className=" col-span-10 mt-2 grid grid-cols-4 gap-3 p-1 overflow-scroll  scroll">
                  //           {storeImage?.map((val, i) => {
                  //             return (
                  //               <div
                  //                 className="w-24 h-24  relative  p-1.5 overflow-hidden"
                  //                 key={i}
                  //               >
                  //                 <div
                  //                   className="absolute cursor-pointer  -top-0 right-0.5 rounded-full bg-red-400 text-white p-0.5"
                  //                   // onClick={() => RemoveImage(i)}
                  //                 >
                  //                   <MdClose />
                  //                 </div>
                  //                 <img
                  //                   src={
                  //                     val.path
                  //                       ? `${process.env.REACT_APP_API_URL}/${val.path}`
                  //                       : URL.createObjectURL(val)
                  //                   }
                  //                   alt="Loading..."
                  //                   className="object-cover w-24 h-24 object-top"
                  //                 />
                  //               </div>
                  //             );
                  //           })}
                  //         </div>
                  //       </div>
                  //       <input
                  //         id="image"
                  //         type={val.type}
                  //         accept={val.accept}
                  //         name={val.apikey}
                  //         onChange={(e) => handleChange(e)}
                  //         className="bg-white hidden relative z-50  outline-none rounded-sm
                  //           border-none px-2 py-1"
                  //       />
                  //     </div>
                  //   );
                  // }
                  else {
                    return (
                      <div key={i}>
                        <div className="my-2">
                          <label
                            className="cursor-pointer capitalize "
                            htmlFor={val.apikey}
                          >
                            {val.label}
                          </label>
                        </div>
                        <div>
                          {" "}
                          <Field
                            id={val.apikey}
                            type={val.type}
                            name={val.apikey}
                            placeholder={val.placeholder}
                            className={` ${
                              val.apikey ? "focus:border-blue-800" : ""
                            } w-full p-2 placeholder:capitalize placeholder:text-sm placeholder:font-light  outline-none border border-gray-200 rounded-[4px]`}
                          />
                        </div>
                        <div
                          className={`${
                            errors[val.apikey] && touched[val.apikey]
                              ? " bg-red-50 w-full p-1 my-1 text-red-500 text-sm"
                              : ""
                          }`}
                        >
                          {errors[val.apikey] && touched[val.apikey]
                            ? errors[val.apikey]
                            : ""}
                        </div>
                      </div>
                    );
                  }
                })}
                <div>
                  <button
                    type="submit"
                    className="bg-[#37535c] mt-7  hover:opacity-80 
                        rounded-md font-medium px-5 py-2 text-white capitalize "
                  >
                    submit
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

export default AddBooking;
